import { SidebarProps } from "@omni/types/components/props/sidebar.props";
import { attempt } from "@omni/utils/function.utils";
import { ReactNode, useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { SidebarContextProvider } from "@/components/Navigation/Sidebar/context/sidebar.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as FlyoutCategoriesSelectors from "@/redux/modules/value/flyoutCategories/flyoutCategories.selectors";
import * as HeaderModule from "@/redux/modules/value/header/header.module";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";

type Props = {
    children: ReactNode;
} & SidebarProps;

export const Base = ({
    accountLinks,
    profilelink,
    innerHTML,
    children
}: Props) => {
    const [assortimentOpen, setAssortimentOpen] = useState<boolean>(false);

    const [activeCategoryIndexes, setActiveCategoryIndexes] = useState<
        Array<number>
    >([]);

    const rootCategory = useSelector(
        FlyoutCategoriesSelectors.getFlyoutCategories
    );

    const sidebarActive = useSelector(HeaderSelectors.isSidebarActive);
    const subCategoriesActive = !!activeCategoryIndexes.length;

    const dispatch = useThunkDispatch();

    const handleOnClose = useCallback(() => {
        dispatch(HeaderModule.update({ sidebarActive: !sidebarActive }));
        setActiveCategoryIndexes([]);
        setAssortimentOpen(false);
    }, [sidebarActive, dispatch]);

    const parsedAccountLinks = useMemo(() => {
        return attempt(() => JSON.parse(accountLinks), []);
    }, [accountLinks]);

    if (!rootCategory) return null;

    return (
        <SidebarContextProvider
            open={sidebarActive}
            rootCategory={rootCategory}
            accountLinks={parsedAccountLinks}
            profileLink={profilelink}
            innerHtml={innerHTML}
            activeCategoryIndexes={activeCategoryIndexes}
            assortimentOpen={assortimentOpen}
            subCategoriesActive={subCategoriesActive}
            setAssortimentOpen={setAssortimentOpen}
            setActiveCatetoryIndexes={setActiveCategoryIndexes}
            onClose={handleOnClose}
        >
            {children}
        </SidebarContextProvider>
    );
};
